"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.HeaderEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slices_1 = require("../slices");
var entity_factory_1 = require("./entity-factory");
var extractLevelValue = function (level) { return parseInt(level[level.length - 1]); };
var getItemsFromLevel = function (level, startIndex, items) {
    var nextLevelItems = {};
    for (var i = startIndex; i < items.length; i++) {
        var itemLevel = extractLevelValue(items[i].level);
        if (itemLevel < level) {
            return nextLevelItems;
        }
        if (itemLevel == level) {
            nextLevelItems[i] = items[i];
        }
    }
    return nextLevelItems;
};
var processSubmenuItem = function (_a, logger) {
    var level = _a.level, startIndex = _a.startIndex, parentLabel = _a.parentLabel, items = _a.items;
    var levelItems = getItemsFromLevel(level, startIndex, items);
    return Object.entries(levelItems)
        .reduce(function (acc, _a) {
        var index = _a[0], item = _a[1];
        return __spreadArray(__spreadArray([], acc), [
            {
                label: logger.required(fields_1.toText(item.label)),
                link: fields_1.toLink(item.link, logger),
                items: processSubmenuItem({
                    level: level + 1,
                    startIndex: parseInt(index) + 1,
                    items: items
                }, logger),
                parentLabel: parentLabel,
                isLanding: logger.required(fields_1.toBoolean(item.isLanding))
            },
        ]);
    }, [])
        .filter(function (item) { return item.link || !utils_1.isVoid(item.items); });
};
var processMenuItem = function (_a, logger) {
    var primary = _a.primary, items = _a.items;
    var label = logger.required(fields_1.toText(primary === null || primary === void 0 ? void 0 : primary.label));
    return utils_1.compact({
        label: label,
        description: logger.required(fields_1.toRichText(primary === null || primary === void 0 ? void 0 : primary.description, logger)),
        image: logger.required(fields_1.toImage(primary === null || primary === void 0 ? void 0 : primary.image, logger)),
        items: processSubmenuItem({
            level: 1,
            startIndex: 0,
            parentLabel: label,
            items: items
        }, logger)
    });
};
var MENUCTASCOPE_PRISMIC_TO_LGLP = {
    Investisseurs: types_1.MenuCtaScope.Investors
};
var processMenuCtasItem = function (_a, logger) {
    var primary = _a.primary, items = _a.items;
    var cta = logger.required(field_groups_1.toCta(primary, logger));
    if (!cta) {
        return undefined;
    }
    return utils_1.compact({
        cta: cta,
        activeOn: logger.toConstValue(primary.activeOn, MENUCTASCOPE_PRISMIC_TO_LGLP)
    });
};
exports.HeaderEntity = entity_factory_1.entityFactory(types_1.DocumentType.HEADER, function (prismicDoc, normalizedEntity, logger) {
    var _a, _b, _c, _d, _e, _f;
    return utils_1.compact(__assign(__assign({}, normalizedEntity), { uid: types_1.DocumentType.HEADER, type: types_1.DocumentType.HEADER, logo: logger.required(fields_1.toImage((_a = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _a === void 0 ? void 0 : _a.main_logo, logger)), mainMenu: logger.required(slices_1.processSlices({ menu: processMenuItem }, (_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.menu_slices, logger)), menuCtas: (_d = slices_1.processSlices({ menu_cta: processMenuCtasItem }, (_c = prismicDoc.data) === null || _c === void 0 ? void 0 : _c.menu_ctas_slices, logger)) === null || _d === void 0 ? void 0 : _d.filter(Boolean), searchMenu: {
            label: logger.required(fields_1.toText((_e = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _e === void 0 ? void 0 : _e.search_label)),
            link: fields_1.toLink((_f = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _f === void 0 ? void 0 : _f.search_link, logger)
        } }));
});
//# sourceMappingURL=header.js.map